import template from './leave_taken_report_full.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeaveTakenFullViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.include_resigned = ko.observable(false);

		let firstDay = moment().format('YYYY-MM-01');
		let lastDay = moment().format('YYYY-MM-') + moment().daysInMonth();

		this.leave_taken_full = ko.observableArray('');
		this.current_department_id = ko.observable();
		this.current_company_id = ko.observable();

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();

		this.range_start = ko.observable(new Date(firstDay).toJSON().slice(0, 10));
		this.range_end = ko.observable(new Date(lastDay).toJSON().slice(0, 10));

		this.selected_company.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_company_id(newValue.company_id);
				this.page.updateData();
			}
			else
			{
				this.current_company_id(null);
				this.page.updateData();
			}
		});

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});
		
		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.range_start.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout) 
				clearTimeout(this.start_date_timeout);
			

			// Set new timeout to wait for user to finish typing or selecting date
			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, "YYYY-MM-DD", true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.range_end(month_end);

				// Trigger data update
				this.page.updateData();
			}, 500); // Wait 100ms after last interaction
		});

		this.range_end.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout)
				clearTimeout(this.end_date_timeout);

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, "YYYY-MM-DD", true);
				if (!ed.isValid()) return;

				if (newValue.length === 10) {
					let sd = moment(this.range_start(), "YYYY-MM-DD", true);
					if (sd.isValid() && ed.isBefore(sd)) {
						Grape.alerts.alert({
							type: 'error',
							title: tr('Invalid Date Range'),
							message: tr('End date cannot be before start date')
						});
						return;
					}
					this.page.updateData();
				}
			}, 1000);
		});

		this.include_resigned.subscribe((newText) => {
			this.page.updateData();
		});
	}

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	show_report_help()
	{
		Grape.dialog.open('LeaveTakenBreakdownByLeaveEntryHelp', { 'employee_id': this.page.bindings.id }, {});
	}

	async download_clicked(v, e)
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('leave_taken_report'));

		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;

		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'leave_taken_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

class ReportTakenLeaveFullPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportLeaveTakenFullViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('LeaveTakenBreakdownReport'))
			return;

		document.title = tr('Leave Taken Breakdown By Leave Entry');
		window.current_page_title(tr('Leave Taken Breakdown By Leave Entry'));
	}

	updateData()
	{
		// must satisfy all 3 conditions
		if (
			this.viewModel.range_start() != '' &&
			this.viewModel.range_start() != undefined &&
			this.viewModel.range_end() != '' &&
			this.viewModel.range_end() != undefined
		)
			this.updateReportData();
	}

	async updateReportData()
	{
		let data = {
			company_id: this.viewModel.current_company_id(),
			department_id: this.viewModel.current_department_id(),
			date_start: this.viewModel.range_start(),
			date_end: this.viewModel.range_end(),
			include_resigned: this.viewModel.include_resigned()
		};

		this.viewModel.leave_taken_full('');
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/reports/leave_taken_full', data);

		if (res)
		{
			if (res.leave_per_employee != null) { this.viewModel.leave_taken_full(res.leave_per_employee); }
			this.viewModel.loader(false);
		}
	}
}

export default {
	route: '[/]report/leave_taken_full',
	page_class: ReportTakenLeaveFullPage,
	template: template,
	template_filename: 'translation/leave_taken_report_full'
};
